import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import { Container, Title } from "@bw/bits"
import { SideMenu } from "@bw/partials"
import { useTranslation } from "react-i18next"
import { breakpoints } from "../../../theme"
import useWindowWidth from "../../../hooks/useWindowWidth"
import Sticky from "react-stickynode"

const Wrapper = styled.div`
  display: grid;
  flex-direction: column;
  gap: 26px;

  @media (min-width: ${breakpoints.medium}px) {
    grid-template-columns: 268px auto;
  }

  .container {
    padding: 0;
  }

  .section:first-child {
    margin-top: 0;
  }

  .grid {
    grid-column-gap: 12px;
    grid-row-gap: 14px;
  }

  .grid--3 {
    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));

    @media (min-width: ${breakpoints.medium}px) {
      grid-template-columns: repeat(auto-fill, minmax(210px, 1fr));
    }
  }
`

const MobileHidden = styled.div`
  display: block;
  @media (min-width: ${breakpoints.medium}px) {
    display: none;
  }
`

const SidebarLayout = ({ sidemenu, children }) => {
  const { t } = useTranslation()
  const size = useWindowWidth()

  return (
    <Container>
      <MobileHidden>
        <Title
          size="h4"
          level="div"
          suptitle={t("sidemenu.the")}
          title={t("sidemenu.title")}
        />
      </MobileHidden>
      <Wrapper>
        {sidemenu ? (
          <Sticky
            enabled={size >= breakpoints.medium}
            top={150}
            bottomBoundary="#bottomSticky"
          >
            <SideMenu
              tabs={sidemenu.map(tab => ({
                title: tab.title,
                to: tab.slug,
              }))}
            />
          </Sticky>
        ) : (
          <div />
        )}
        <div>{children}</div>
      </Wrapper>
      <div id="bottomSticky" />
    </Container>
  )
}

SidebarLayout.propTypes = {
  sidemenu: PropTypes.arrayOf(
    PropTypes.shape({
      slug: PropTypes.string,
      title: PropTypes.string,
    })
  ),
}

export { SidebarLayout }
